/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneNewsletterSignup from 'sites/allas/components/standalone/NewsletterSignup';

export const DynamicStandaloneNewsletterSignup = StandaloneNewsletterSignup;
export type DynamicStandaloneNewsletterSignupProps = PropsFromComponent<typeof StandaloneNewsletterSignup>;

export const DynamicStandaloneNewsletterSignupWith = (extras: DynamicStandaloneExtras): typeof StandaloneNewsletterSignup => {
    return function DynamicStandaloneNewsletterSignup(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'NewsletterSignup');
        return <StandaloneNewsletterSignup {...mergeProps({ options: { theme } }, props)} />;
    }
}